import { optionSchema } from "@/common/schemas/option.schema";
import z from "zod";

export const objectivePartsSchema = z.object({
  display_name: z
    .string({ message: 'Campo obrigatório' })
    .trim()
    .min(3, { message: 'Tamanho mínimo: 3 caracteres' }),
  system_parts_attributes: z
    .array(optionSchema, { message: 'Selecione pelo menos um sistema' })
    .min(1, { message: 'Selecione pelo menos um sistema' }),
});

export type ObjectivePartsValidationSchema = z.infer<typeof objectivePartsSchema>;
